var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.756836,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#EDD5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71875 16.7568C7.71875 12.2005 11.4124 8.50684 15.9688 8.50684C20.5251 8.50684 24.2188 12.2005 24.2188 16.7568C24.2188 21.3132 20.5251 25.0068 15.9688 25.0068C11.4124 25.0068 7.71875 21.3132 7.71875 16.7568ZM15.9688 7.00684C10.584 7.00684 6.21875 11.3721 6.21875 16.7568C6.21875 22.1416 10.584 26.5068 15.9688 26.5068C21.3535 26.5068 25.7188 22.1416 25.7188 16.7568C25.7188 11.3721 21.3535 7.00684 15.9688 7.00684ZM16.7188 13.7568C16.7188 13.3426 16.383 13.0068 15.9688 13.0068C15.5545 13.0068 15.2188 13.3426 15.2188 13.7568V17.5068C15.2188 17.921 15.5545 18.2568 15.9688 18.2568C16.383 18.2568 16.7188 17.921 16.7188 17.5068V13.7568ZM15.9688 19.7568C15.5545 19.7568 15.2188 20.0926 15.2188 20.5068V20.5143C15.2188 20.9285 15.5545 21.2643 15.9688 21.2643H15.9762C16.3905 21.2643 16.7262 20.9285 16.7262 20.5143V20.5068C16.7262 20.0926 16.3905 19.7568 15.9762 19.7568H15.9688Z",
    fill: "#A72E12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIndicator);
export default __webpack_public_path__ + "static/media/warning-indicator.3e0be6fd7185a71f3b94beb637432561.svg";
export { ForwardRef as ReactComponent };